import { Link, useLocation } from "react-router-dom";
import { PRODUCT_PILLARS } from "../../data/landingContent";
import Reveal from "./Reveal";
import LiquidGlassZone from "./LiquidGlassZone";
import LiquidGlassCard from "./LiquidGlassCard";

function pillarTo(item, isHome) {
  if (item.id === "physio") return item.link;
  if (item.id === "agents") {
    return isHome ? { pathname: "/", hash: "agents" } : { pathname: "/products", hash: "agents" };
  }
  if (item.id === "emr" || item.id === "hms") {
    return { pathname: "/products", hash: item.hash || "products-modules" };
  }
  return item.link;
}

export default function ProductPillars({ showHeader = true, className = "" }) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <section className={`product-pillars-section ${className}`.trim()} aria-labelledby="product-pillars-heading">
      <div className="wrap">
        {showHeader && (
          <>
            <span className="kicker">Products</span>
            <h2 className="section-title" id="product-pillars-heading">
              AI HMS, EMR, <b>physio &amp; agents</b>
            </h2>
            <p className="section-lede">
              Four pillars of Deepaarogya — one hospital chart. Physiotherapist desk is our flagship
              for rehab clinics and orthopedic centres.
            </p>
          </>
        )}

        <Reveal as="div" className="product-pillars-shell reveal-stagger">
          <LiquidGlassZone className="product-pillars-grid-wrap">
            <div className="product-pillars-grid">
              {PRODUCT_PILLARS.map((pillar) => (
                <LiquidGlassCard
                  key={pillar.id}
                  as={Link}
                  to={pillarTo(pillar, isHome)}
                  className={`product-pillar-card ${pillar.featured ? "is-featured" : ""}`}
                >
                  {pillar.featured && <span className="product-pillar-flag">Flagship</span>}
                  <span className="product-pillar-icon" aria-hidden="true">
                    {pillar.icon}
                  </span>
                  <h3>{pillar.title}</h3>
                  <p>{pillar.desc}</p>
                  <span className="product-pillar-cta">
                    See details
                    <span aria-hidden="true"> →</span>
                  </span>
                </LiquidGlassCard>
              ))}
            </div>
          </LiquidGlassZone>
        </Reveal>
      </div>
    </section>
  );
}
